import SchoolCard from "components/main-view/utils/cards/SchoolCard";
import EmptyView from "components/main-view/utils/components/EmptyView";
import { SchoolListType } from "utils/interfaces";
import { LoadingDots } from "utils/loadingAnimation";

interface MasterAdminDashboardListProps {
  data: SchoolListType[];
  searchQuery: string;
  isLoadingData: boolean;
  handleCardClick: (card: SchoolListType) => (event: React.MouseEvent) => void;
  handleClickEdit: (card: SchoolListType) => (event: React.MouseEvent) => void;
  handleClickDelete: (
    card: SchoolListType,
  ) => (event: React.MouseEvent) => void;
  onCreateEditSchool: (
    type: "create" | "edit",
    title?: string,
    description?: string,
  ) => void;
}

const MasterAdminDashboardList: React.FC<MasterAdminDashboardListProps> = ({
  data,
  searchQuery,
  isLoadingData,
  handleCardClick,
  handleClickEdit,
  handleClickDelete,
  onCreateEditSchool,
}) => {
  /**
   * Function that renders the list of cards depending of the activeClass selected
   * @returns a list of cards
   */
  const cardsToRender = () => {
    return data && data.length > 0 ? (
      data
        .filter((item: SchoolListType) =>
          item.name.toLowerCase().includes(searchQuery.toLowerCase()),
        )
        .map((school: SchoolListType, index: number) => (
          <SchoolCard
            key={index}
            school={school}
            handleCardClick={handleCardClick(school)}
            handleClickEdit={handleClickEdit(school)}
            handleClickDelete={handleClickDelete(school)}
          />
        ))
    ) : !isLoadingData ? (
      <EmptyView
        showCreateNew={true}
        onCreateNewClick={() => onCreateEditSchool("create")}
      />
    ) : (
      <div className="w-full h-full flex justify-center items-center">
        <LoadingDots bgColor="bg-neutral-300" />
      </div>
    );
  };

  return (
    <div className="w-full h-full flex-col justify-start items-start gap-4 inline-flex overflow-y-auto custom-scroll">
      {cardsToRender()}
    </div>
  );
};

export default MasterAdminDashboardList;
